module.exports = __webpack_public_path__ + "static/img/6.c48ea20.jpg";